<template>
  <!-- eslint-disable -->
  <div class="container-fluid">
    <div class="row header">
      <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
        <p class="dg-header-label">Style</p>
        <p class="h1 dg-header">Links</p>
        <p>Links are references to other documents or pages and can send a user to an internal or external source. Primarily, they are used for navigation. Links should be clear in their function and destination.</p>
      </div>
    </div>

    <div class="row content">
      <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
        <!-- Content -->

        <div class="row">
          <div class="col">
            <p class="h4 dg-subheader">A few Examples</p>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestiae <a href="#">link text</a> earum aut nobis quos, aperiam voluptates eaque ab illum repellendus accusantium est. Quam <a href="#" class="active">link text active</a> corporis vero sint, ea praesentium aspernatur?</p>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col">
            <p class="h4 dg-subheader">Code</p>
            <div class="code-sample">
              &lt;!-- Link Text --&gt;<br/>
              &lt;a href="#"&gt;link text&lt;/a&gt;<br/>
              <br/>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col">
            <p class="h4 dg-subheader">Variants / Modifiers</p>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis reprehenderit consequatur, laudantium ad vel ipsa officia dolorum? Quaerat, soluta ipsa, quibusdam necessitatibus officia, laudantium tenetur cupiditate cum nesciunt deleniti veritatis!</p>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col">
            <p class="h4 dg-subheader">Accessibility</p>
            <p>Links must have a non-empty <span class="code">href</span> attribute in order to be considered true links and to be accessible to keyboard users.</p>
          </div>
        </div>
      </div>
    </div>  
  </div>
  <!-- eslint-enable -->
</template>

<script>
export default {
  name: "Links"
};
</script>

/* esling-disable */
<style lang="sass?outputStyle=expanded">
</style>
/* eslint-enable */



// WEBPACK FOOTER //
// src/components/routes/Links.vue